export class BasicWorkOrderRequest {
  WorkOrderID: number;
  ConveyanceID: number;
  IncludeMetadata: string[];
}
